import React from 'react';
import WhiteLabelBilling from './WhiteLabelBilling';
import ProfileNavbar from '../Profile/ProfileNavbar';

/**
 * Component to handle subscription status checking and display subscription purchase UI
 * This component is shown when user doesn't have white label addon subscription
 */
const SubscriptionCheck = ({ onPurchaseSuccess }) => {
  return (
    <div className="white-label-settings">
      <WhiteLabelBilling
        onPurchaseSuccess={onPurchaseSuccess}
      />
    </div>
  );
};

export default SubscriptionCheck;
